import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCircleCheck as faCircleCheckRegular, faCircleXmark as faCircleXmarkRegular, faFileLines as faFileLinesRegular } from '@fortawesome/free-regular-svg-icons';
import { faDownload, faHourglassHalf, faXmark, faCheck, faPenToSquare, faChartSimple, faBolt, faFire, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faPaperclipVertical } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true
})
export class App {
  private library = inject(FaIconLibrary);

  constructor() {
    this.library.addIcons(
      faCircleCheckRegular,
      faCircleXmarkRegular,
      faPenToSquare,
      faChartSimple,
      faBolt,
      faFire,
      faTriangleExclamation,
      faPaperclipVertical,
      faFileLinesRegular,
      faCheck,
      faXmark,
      faHourglassHalf,
      faDownload
    );
  }
}
